import keys from 'lodash/keys';
import pickBy from 'lodash/pickBy';
import { isEmpty } from 'lodash/isEmpty';

export const ZOOMFORTH_COMPANY_EMAIL_DOMAIN = '@zoomforth.com';

export const ignoreZoomforthUsers = ()=> {
  // we need both of these in order to account for events that 
  // were generated before the public user system was implemented
  return [{
    property_name: 'user.zoomforth_user_id',
    operator: 'eq',
    property_value: null        
  }];
};


export const ignoreZoomforthCompanyUsers = ()=> {
  /**
   * @TODO:   
   * - we need clearer rules related to special casing Zoomforth users out of analytics results
   *  - we need to be able to clearly know when to send notifications or not.
   *  - right now we are IGNORING events when (the identified email is `@zoomforth.com` and the visitor was a zoomforth user), 
   *      UNLESS the user making the query has a zoomforth.com email address
   *  - as it stands, this may be kind of buggy, and it's certainly difficult to figure out in terms of ensuring a synced up notification situation.
   *  - what exactly is the specific case when we want to be filtering out `zoomforth.com` visits?
   *    - what is the simplest rule that can describe that?
   *    - we will want to determine that on the server side, and make that a flag on the event.
   */
  return [
    {
      operator: 'or',
      operands: [
        {
          // Only display visitors who are not Zoomforth users
          property_name: 'user.zoomforth_user_id',
          operator: 'eq',
          property_value: null        
        },
          // OR
          //
          // visitors who are Zoomforth users, only display them
          // if their email is not the zoomforth company email
        {
          property_name: 'user.public_user.email',
          operator: 'not_contains',
          property_value: ZOOMFORTH_COMPANY_EMAIL_DOMAIN
        }
      ]
    }
  ];
};

export const ignoreAnonymousUsers = () => {
  return {
    property_name: 'user.public_user.email',
    operator: 'exists',
    property_value: true
  };
};

export const excludeSelectedPublicEmailDomains = (excludedPublicEmailDomains={}) => {
  let excludedDomains = keys(pickBy(excludedPublicEmailDomains)); // default truthy

  return excludedDomains.map((exd, i) => {
    return {
      property_name: 'user.public_user.email',
      operator: 'not_contains',
      property_value: exd
    };
  });
};

// TODO(?): param validation
export const filterConstructor = (
  customQuery=[],
  options={
    ignoreZoomforthUsers: true,
    ignoreZoomforthCompanyUsers: true,
    ignoreAnonymousUsers: true,
    filteredEmailDomains: []
  }
) => {
  return (
    customQuery.concat(
      options.ignoreZoomforthUsers ? ignoreZoomforthUsers() : [],
      options.ignoreZoomforthCompanyUsers ? ignoreZoomforthCompanyUsers() : [],
      options.ignoreAnonymousUsers ? ignoreAnonymousUsers() : [],
      excludeSelectedPublicEmailDomains(options.filteredEmailDomains),
    )
  );
};

export default {
  filterConstructor,
  ignoreZoomforthUsers,
  ignoreZoomforthCompanyUsers,
  excludeSelectedPublicEmailDomains
};
